import React, { useState, useEffect, useRef } from "react";
import { FormControl, Grid } from "@mui/material";
import FormLabels from "../../../../library/custom/formLabel/FormLabels";
import SearchAutoComplete from "../../../../library/custom/searchAutoComplete/SearchAutoComplete";
import SelectMenu from "../../../../library/custom/selectMenu/SelectMenu";
import Buttons from "../../../../library/custom/button/Button";
import { InputField } from "../../../../library/custom/textBox/InputField";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import {
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  ORG_NAME,
  PAGE_SIZE,
  PRODUCT_LIST,
  ROW_PER_PAGE_SIZE,
  TRAINING_OPTION,
} from "../../../../constant/constant";

import { useNavigate } from "react-router-dom";
import NORow from "../../../../library/custom/noRow/noRow";
import { TableLoader } from "../../../../library/common/Loader";
import {
  getRandomNumber,
  getServiceTypeNames,
  parseDate,
} from "../../../../utils/helper";
import GridTable from "../../../../library/custom/gridTable/GridTable";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import {
  COURSESDETAIL,
  LESSONDETAIL,
  LMS_CLIENT_LESSON_MAPPING,
} from "../../../../constant/routeContant";
import ReportFilter from "../../../inspections/component/reprimand/reportFilter";
import FilterCommonStatusSelect from "../../../admin/shared/FilterCommonStatusSelect";
import "./lmsClientMapping.scss";
import { useLocation } from "react-router-dom";
import { useDebounce } from "../../../../utils/useDebounceSearch";

const LmsClientMapping = ({
  searchClient,
  isSearchClientLoading,
  allClients,
  changesearchauto,
  setchangesearchauto,
  searchLessons,
  searchLessonsData,
  searchCourses,
  searchCoursesData,
  getMappedGlobalLessonListApi,
  getMappedGlobalCourseListApi,
  MappedGlobalLessonListData,
  MappedGlobalCourseListData,
  lessons,
  setlessons,
  clients,
  setClients,
  trainigtype,
  setTrainigtype,
  FinalaData,
  setFinalaData,
  FinalaCourseData,
  setFinalaCourseData,
  FinalaDataClientSide,
  setFinalaDataClientSide,
  FinalaCourseDataClientSide,
  setFinalaCourseDataClientSide,
  lessonCount,
  courseCount,
  categoryListData,
  postLessonOrgMapping,
  postCourseOrgMapping,
  tabclick,
  settabclick,
  courseid,
  setcourseid,
  lessonid,
  setlessonid,
  isTableLoading,
  setisTableLoading,
  courses,
  setcourses,
  page,
  setPage,
  search,
  setSearch,
  categoryId,
  setIsCategoryId,
  serviceTypeId,
  setServiceTypeId,
  isMapped,
  setIsMapped,
  pageSize,
  setPageSize,
  setLessonCount,
  setCourseCount,
  searchClients,
  setSearchClients,
  isSearchCoursesLoading,
  isSearchLessonsLoading,
  lessonCourseMapped,
  clientMapped,
  selectedClientRows,
  selectedLessonCourseRows,
  setLessonCourseMapped,
  setClientMapped,
  setSelectedClientRows,
  setSelectedLessonCourseRows,
}) => {
  const location = useLocation();

  const history = useNavigate();
  const navigate = useNavigate();
  const autoComp = useRef(null);
  const autoCompCourses = useRef(null);
  const [lessonname, setlessonname] = useState("");
  const [coursename, setcoursename] = useState("");
  // Error and duplicate state code
  const [islessonSearchError, setislessonSearchError] = useState(false);
  const [isclientlessonSearchError, setisclientlessonSearchError] =
    useState(false);
  const [isclientCourseSearchError, setisclientCourseSearchError] =
    useState(false);
  const [iscourseSearchError, setiscourseSearchError] = useState(false);
  const autoCompLesson = useRef();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPaginationChanging, setIsPaginationChanging] = useState(false);
  const debouncedSearch = useDebounce(search, 500);
  const debouncedSearchClients = useDebounce(searchClients, 500);
  const [clientSearchText, setClientSearchText] = useState("");
  const debouncedClientSearch = useDebounce(clientSearchText, 500);
  const [lessonSearchText, setLessonSearchText] = useState("");
  const debouncedLessonSearch = useDebounce(lessonSearchText, 500);

  const lessonCourserows =
    trainigtype === 1 ? (FinalaData ?? []) : (FinalaCourseData ?? []);
  const clientRows =
    trainigtype === 1
      ? FinalaDataClientSide
      : (FinalaCourseDataClientSide ?? []);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const onclicktab = (val) => {
    settabclick(val);
    setTrainigtype(1);
    setFinalaData([]);
    setLessonCount();
    setCourseCount();
    setFinalaCourseData([]);
    setFinalaCourseDataClientSide([]);
    setFinalaDataClientSide([]);
    setlessons("");
    setlessonid("");
    setlessonname("");
    setcourses("");
    setcourseid("");
    setcoursename("");
    setislessonSearchError(false);
    setiscourseSearchError(false);
    setisclientlessonSearchError(false);
    setisclientCourseSearchError(false);
    setchangesearchauto({ key: "", value: "" });
    setClients("");
    setSearchClients("");
    setSearch("");
    setIsCategoryId("");
    setIsMapped("");
    setServiceTypeId("");
    setLessonCourseMapped(new Set());
    setClientMapped(new Set());
    setSelectedClientRows(new Set());
    setSelectedLessonCourseRows(new Set());
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  useEffect(() => {
    if (changesearchauto?.key && tabclick === 1) {
      const data = {
        clientId: parseInt(changesearchauto?.key),
        page: page,
        pageSize: pageSize,
        lesson: search ? search : "",
        isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
        categoryId: categoryId ? categoryId : "",
        serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
      };
      if (trainigtype === 1) {
        data.lessonId = 0;
        data.lesson = search;
        getMappedGlobalLessonListApi(data);
      } else {
        data.courseId = 0;
        data.course = search;
        getMappedGlobalCourseListApi(data);
      }
    }
  }, [changesearchauto, trainigtype]);

  useEffect(() => {
    if ((lessonid || courseid) && tabclick === 2) {
      const data = {
        clientId: 0,
        page: page,
        pageSize: pageSize,
        lesson: search ? search : "",
        isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
        categoryId: categoryId ? categoryId : "",
        serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
      };
      if (trainigtype === 1) {
        data.lessonId = lessonid;
        data.client = searchClients;
        getMappedGlobalLessonListApi(data);
      } else {
        data.courseId = courseid;
        data.client = searchClients;
        getMappedGlobalCourseListApi(data);
      }
    }
  }, [lessonid, courseid, trainigtype]);

  // const typeOnchange = (event, value) => {
  //   searchClient(event?.target?.value);
  // };
  const onChangeClients = (value) => {
    if (value === null) {
      setFinalaData([]);
      setFinalaCourseData([]);
      setLessonCount();
      setCourseCount();
    }
    setchangesearchauto({ key: value?.key ?? "", value: value?.value ?? "" });
    setClients(value);
    setisclientlessonSearchError(false);
    setisclientCourseSearchError(false);
    setLessonCourseMapped(new Set());
    setClientMapped(new Set());
    setSelectedClientRows(new Set());
    setSelectedLessonCourseRows(new Set());
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const onChangeTrainingType = (e) => {
    setSearch("");
    setSearchClients("");
    setTrainigtype(e?.target?.value);
    setFinalaData([]);
    setIsCategoryId("");
    setIsMapped("");
    setServiceTypeId("");
    setlessonid("");
    setcourseid("");
    setLessonCount("");
    setCourseCount("");
    if (tabclick === 1) {
      setlessons("");
      setcourses("");
      setlessonname("");
      setcoursename("");
    }
    if (tabclick === 2) {
      setlessons("");
      setcourses("");
      setlessonname("");
      setcoursename("");
      setchangesearchauto({ key: "", value: "" });
      setClients("");
    }
    setislessonSearchError(false);
    setiscourseSearchError(false);
    setisclientlessonSearchError(false);
    setisclientCourseSearchError(false);
    setFinalaCourseDataClientSide([]);
    setFinalaDataClientSide([]);
    setLessonCourseMapped(new Set());
    setClientMapped(new Set());
    setSelectedClientRows(new Set());
    setSelectedLessonCourseRows(new Set());
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const viewLessonOnClick = (lessonId) => {
    navigate(LESSONDETAIL, {
      state: {
        lessonId: lessonId,
        isAdminLesson: false,
        isMapping: true,
        clientId: clients,
        page: page,
        pageSize: pageSize,
        lesson: search ?? "",
        search: search,
        client: search,
        searchClients: searchClients,
        isMapped: isMapped ?? "",
        categoryId: categoryId ?? "",
        serviceTypeId: serviceTypeId ?? "",
        tabclick: tabclick,
        trainigtype: trainigtype,
        lessons: lessons,
        routeText: "Back to LMS Mapping",
        route: LMS_CLIENT_LESSON_MAPPING,
        lessonCourseMapped: lessonCourseMapped,
        clientMapped: clientMapped,
        selectedClientRows: selectedClientRows,
        selectedLessonCourseRows: selectedLessonCourseRows,
      },
    });
  };
  const viewCourseOnClick = (courseId) => {
    navigate(COURSESDETAIL, {
      state: {
        courseId: courseId,
        isAdminCourse: false,
        isMapping: true,
        clientId: clients,
        page: page,
        pageSize: pageSize,
        course: search,
        search: search,
        searchClients: searchClients,
        isMapped: isMapped ?? "",
        categoryId: categoryId ?? "",
        serviceTypeId: serviceTypeId ?? "",
        tabclick: tabclick,
        trainigtype: trainigtype,
        courses: courses,
        client: search,
        routeText: "Back to LMS Mapping",
        route: LMS_CLIENT_LESSON_MAPPING,
        lessonCourseMapped: lessonCourseMapped,
        clientMapped: clientMapped,
        selectedClientRows: selectedClientRows,
        selectedLessonCourseRows: selectedLessonCourseRows,
        courseDetailBackPath: location?.pathname,
      },
    });
  };

  const columnsLms = [
    {
      field: "lessonName",
      headerName: "Lesson Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "categoryName",
      headerName: "Category",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "isMapped",
      headerName: "Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        return <div>{rows?.row?.isMapped ? "Yes" : "No"}</div>;
      },
    },
    {
      field: "mappedDate",
      headerName: "Date Last Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const dateString = rows?.row?.mappedDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const mappedDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{mappedDate}</div>;
      },
    },
    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewLabel="View Lesson"
            viewOnClick={() => viewLessonOnClick(rows?.row?.lessonId)}
          />
        );
      },
    },
  ];
  const columnsLmsCourse = [
    {
      field: "courseName",
      headerName: "Course Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "categoryName",
      headerName: "Category",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "isMapped",
      headerName: "Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        return <div>{rows?.row?.isMapped ? "Yes" : "No"}</div>;
      },
    },
    {
      field: "mappedDate",
      headerName: "Date Last Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const dateString = rows?.row?.mappedDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const mappedDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{mappedDate}</div>;
      },
    },
    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewLabel="View Course"
            viewOnClick={() => viewCourseOnClick(rows?.row?.courseId)}
          />
        );
      },
    },
  ];
  const columnsClients = [
    {
      field: "clientName",
      headerName: "Client Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const serviceTypes = rows?.row?.serviceType || [];
        return (
          <div title={getServiceTypeNames(serviceTypes)}>
            {getServiceTypeNames(serviceTypes)}
          </div>
        );
      },
    },
    {
      field: "lessonName",
      headerName: "Lesson Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "categoryName",
      headerName: "Category",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "isMapped",
      headerName: "Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        return <div>{rows?.row?.isMapped ? "Yes" : "No"}</div>;
      },
    },
    {
      field: "mappedDate",
      headerName: "Date Last Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const dateString = rows?.row?.mappedDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const mappedDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{mappedDate}</div>;
      },
    },
    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewLabel="View Lesson"
            viewOnClick={() => viewLessonOnClick(rows?.row?.lessonId)}
          />
        );
      },
    },
  ];
  const columnsClientsCourse = [
    {
      field: "clientName",
      headerName: "Client Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "serviceType",
      headerName: "Service Type",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const serviceTypes = rows?.row?.serviceType || [];
        return (
          <div title={getServiceTypeNames(serviceTypes)}>
            {getServiceTypeNames(serviceTypes)}
          </div>
        );
      },
    },
    {
      field: "courseName",
      headerName: "Course Name",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "categoryName",
      headerName: "Category",
      flex: 2,
      disableColumnMenu: true,
    },
    {
      field: "isMapped",
      headerName: "Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        return <div>{rows?.row?.isMapped ? "Yes" : "No"}</div>;
      },
    },
    {
      field: "mappedDate",
      headerName: "Date Last Mapped",
      flex: 2,
      disableColumnMenu: true,
      renderCell: (rows) => {
        const dateString = rows?.row?.mappedDate;
        const formattedDate =
          dateString && !isNaN(Date.parse(dateString))
            ? new Date(dateString)
            : parseDate(dateString, "MM-dd-yyyy");
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const mappedDate =
          formattedDate instanceof Date && !isNaN(formattedDate)
            ? formattedDate.toLocaleDateString("en-US", options)
            : null;
        return <div>{mappedDate}</div>;
      },
    },
    {
      field: "",
      flex: 1,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            view
            viewLabel="View Course"
            viewOnClick={() => viewCourseOnClick(rows?.row?.courseId)}
          />
        );
      },
    },
  ];
  const typeOnchangeLessons = (event, value) => {
    setLessonSearchText(event?.target?.value);
  };
  const onChangeLessons = (value) => {
    if (value == null && tabclick === 2) {
      setFinalaDataClientSide([]);
      setchangesearchauto({ key: "", value: "" });
      setClients("");
      setLessonCount();
      setCourseCount();
    }
    setlessons(value);
    setlessonname(value?.value);
    setlessonid(value?.key);
    setislessonSearchError(false);
    setiscourseSearchError(false);
    setClientMapped(new Set());
    setSelectedClientRows(new Set());
    setSelectedLessonCourseRows(new Set());
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  const typeOnchangeCourses = (event, value) => {
    searchCourses(value);
  };
  const onChangeCourses = (value) => {
    if (value == null && tabclick === 2) {
      setFinalaCourseDataClientSide([]);
      setchangesearchauto({ key: "", value: "" });
      setClients("");
      setLessonCount();
      setCourseCount();
    }
    setcourses(value);
    setcoursename(value?.value);
    setcourseid(value?.key);
    setiscourseSearchError(false);
    setLessonCourseMapped(new Set());
    setClientMapped(new Set());
    setSelectedClientRows(new Set());
    setSelectedLessonCourseRows(new Set());
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  //  Final submit Data TAB One Lesson/Course
  const addlmsFinalData = () => {
    if (trainigtype === 1) {
      const filteredData = lessonCourseMapped?.map(
        ({ clientOrgId, lessonId, isMapped }) => ({
          clientId: clientOrgId,
          lessonId,
          isMapped,
        }),
      );

      const fData = {
        lessonOrgMapping: filteredData,
      };
      postLessonOrgMapping(fData, changesearchauto?.key);
    } else if (trainigtype === 2) {
      const filteredData = lessonCourseMapped?.map(
        ({ clientOrgId, courseId, isMapped }) => ({
          clientId: clientOrgId,
          courseId,
          isMapped,
        }),
      );
      const fDataCourse = {
        courseOrgMapping: filteredData,
      };
      postCourseOrgMapping(fDataCourse, changesearchauto?.key);
    }
  };
  //  Final submit Data TAB Two Client
  const addClientFinalData = () => {
    if (trainigtype === 1) {
      const filteredData = clientMapped?.map(
        ({ clientOrgId, lessonId, isMapped }) => ({
          clientId: clientOrgId,
          lessonId,
          isMapped,
        }),
      );
      const fData = {
        lessonOrgMapping: filteredData,
      };
      postLessonOrgMapping(fData, lessonid);
    } else if (trainigtype === 2) {
      const filteredData = clientMapped?.map(
        ({ clientOrgId, courseId, isMapped }) => ({
          clientId: clientOrgId,
          courseId,
          isMapped,
        }),
      );
      const fDataCourse = {
        courseOrgMapping: filteredData,
      };
      postCourseOrgMapping(fDataCourse, courseid);
    }
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      clientId: clients?.key ? parseInt(clients?.key) : 0,
      page: 1,
      pageSize: newPazeSize,
      lesson: search ? search : "",
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = 0;
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = 0;
      getMappedGlobalCourseListApi(data);
    }
  };

  const handleClientPageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    const data = {
      clientId: 0,
      page: 1,
      pageSize: newPazeSize,
      lesson: search ? search : "",
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = lessonid;
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = courseid;
      getMappedGlobalCourseListApi(data);
    }
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    setIsPaginationChanging(true);
    const data = {
      clientId: clients?.key ? parseInt(clients?.key) : 0,
      page: newPage + 1,
      pageSize: pageSize,
      lesson: search ? search : "",
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = 0;
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = 0;
      getMappedGlobalCourseListApi(data);
    }
  };
  const handleClientPagignation = (newPage) => {
    setPage(newPage);
    setIsPaginationChanging(true);
    const data = {
      clientId: 0,
      page: newPage + 1,
      pageSize: pageSize,
      client: searchClients ? searchClients : "",
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = lessonid;
      data.lesson = "";
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = courseid;
      data.course = "";
      getMappedGlobalCourseListApi(data);
    }
  };

  const syncSelectionsWithNewData = () => {
    if (tabclick === 1) {
      const newSelections = new Set(selectedLessonCourseRows);
      const newClientMapped = new Set(clientMapped);
      setSelectedLessonCourseRows(newSelections);
      setClientMapped(newClientMapped);
    } else {
      const newSelections = new Set(selectedClientRows);
      const newLessonCourseMapped = new Set(lessonCourseMapped);
      setSelectedClientRows(newSelections);
      setLessonCourseMapped(newLessonCourseMapped);
    }
  };

  const handleautoSearch = (event) => {
    setPage(0);
    setisTableLoading(true);

    const searchText = event?.target?.value || "";
    setSearch(searchText);

    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };
  useEffect(() => {
    if (!isTableLoading) {
      syncSelectionsWithNewData();
    }
  }, [lessonCourserows, clientRows, isTableLoading]);

  const handleautoSearchClients = (event) => {
    setPage(0);
    setisTableLoading(true);

    const searchText = event?.target?.value || "";
    setSearchClients(searchText);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
  };

  const mappedOnChanges = (e) => {
    setIsMapped(e?.target.value);
  };
  const categoryOnChanges = (e) => {
    setIsCategoryId(e?.target.value);
  };

  const serviceTypeOnChanges = (e) => {
    setServiceTypeId(e?.target.value);
  };

  const handleClear = () => {
    setPage(0);
    setPageSize(PAGE_SIZE);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setServiceTypeId("");
    setIsCategoryId("");
    setIsMapped("");
    setSearch("");
    const data = {
      clientId: clients?.key ? parseInt(clients?.key) : 0,
      page: 1,
      pageSize: PAGE_SIZE,
      lesson: "",
      isMapped: "",
      categoryId: "",
      serviceTypeId: "",
    };
    if (trainigtype === 1) {
      data.lessonId = 0;
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = 0;
      getMappedGlobalCourseListApi(data);
    }
    handleClose();
  };

  const handleClearClients = () => {
    setPage(0);
    setPageSize(PAGE_SIZE);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setIsCategoryId("");
    setIsMapped("");
    setSearchClients("");
    const data = {
      clientId: 0,
      page: 1,
      pageSize: PAGE_SIZE,
      lesson: "",
      isMapped: "",
      categoryId: "",
      serviceTypeId: "",
    };
    if (trainigtype === 1) {
      data.lessonId = lessonid;
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = courseid;
      getMappedGlobalCourseListApi(data);
    }
    handleClose();
  };

  const handleApply = () => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    const data = {
      clientId: clients?.key ? parseInt(clients?.key) : 0,
      page: 1,
      pageSize: pageSize,
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = 0;
      data.lesson = search ? search : "";
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = 0;
      data.course = search ? search : "";
      getMappedGlobalCourseListApi(data);
    }
    handleClose();
  };

  const handleApplyClients = () => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    const data = {
      clientId: 0,
      page: 1,
      pageSize: pageSize,
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };
    if (trainigtype === 1) {
      data.lessonId = lessonid;
      data.client = searchClients ? searchClients : "";
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = courseid;
      data.client = searchClients ? searchClients : "";
      getMappedGlobalCourseListApi(data);
    }
    handleClose();
  };

  useEffect(() => {
    setSelectedLessonCourseRows((prevSelected) => {
      const newSelections = new Set(
        lessonCourserows
          .filter((row) => row.isMapped)
          .map((row) => (trainigtype === 1 ? row.lessonId : row.courseId)),
      );

      return new Set([...prevSelected, ...newSelections]);
    });

    const mappedLessonCourseRows = new Set(
      lessonCourserows?.filter((row) => row.isMapped),
    );
    setLessonCourseMapped(mappedLessonCourseRows);
  }, [lessonCourserows]);

  const handleLessonCourseChange = (newSelection) => {
    const selectionSet = new Set(newSelection);

    if (!isPaginationChanging) {
      setSelectedLessonCourseRows(selectionSet);

      setLessonCourseMapped((prevMapped) => {
        const prevMappedMap = new Map();
        (prevMapped || []).forEach((item) => {
          const key = trainigtype === 1 ? item.lessonId : item.courseId;
          prevMappedMap.set(key, item);
        });
        const updatedMapped = lessonCourserows
          .map((row) => {
            const key = trainigtype === 1 ? row.lessonId : row.courseId;
            const isSelected = selectionSet.has(key);
            if (prevMappedMap.has(key)) {
              return {
                ...prevMappedMap.get(key),
                isMapped: isSelected,
              };
            }
            if (isSelected) {
              return {
                ...row,
                isMapped: true,
              };
            }
            return null;
          })
          .filter(Boolean);

        return updatedMapped;
      });
    } else {
      setIsPaginationChanging(false);
    }
  };

  useEffect(() => {
    setSelectedClientRows((prevSelected) => {
      const newSelections = new Set(
        clientRows.filter((row) => row.isMapped).map((row) => row.clientOrgId),
      );

      return new Set([...prevSelected, ...newSelections]);
    });

    const mappedLessonIds = new Set(clientRows?.filter((row) => row.isMapped));
    setClientMapped(mappedLessonIds);
  }, [clientRows]);

  const handleSelectionChange = (newSelection) => {
    const selectionSet = new Set(newSelection);

    if (!isPaginationChanging) {
      setSelectedClientRows(selectionSet);

      setClientMapped((prevMapped) => {
        const prevMappedMap = new Map();
        (prevMapped || []).forEach((item) => {
          prevMappedMap.set(item.clientOrgId, item);
        });
        const updatedMapped = clientRows
          .map((row) => {
            const isSelected = selectionSet.has(row.clientOrgId);
            if (prevMappedMap.has(row.clientOrgId)) {
              return {
                ...prevMappedMap.get(row.clientOrgId),
                isMapped: isSelected,
              };
            }
            if (isSelected) {
              return {
                ...row,
                isMapped: true,
              };
            }

            return null;
          })
          .filter(Boolean);

        return updatedMapped;
      });
    } else {
      setIsPaginationChanging(false);
    }
  };

  const isFirstRender = useRef(true);
  const isFirstRenderClientSearch = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (tabclick !== 1) return;

    setPage(0);

    const data = {
      clientId: clients?.key ? parseInt(clients?.key) : 0,
      page: 1,
      pageSize: pageSize,
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };

    if (trainigtype === 1) {
      data.lessonId = 0;
      data.lesson = debouncedSearch || "";
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = 0;
      data.course = debouncedSearch || "";
      getMappedGlobalCourseListApi(data);
    }
  }, [debouncedSearch]);

  useEffect(() => {
    if (isFirstRenderClientSearch.current) {
      isFirstRenderClientSearch.current = false;
      return;
    }

    if (tabclick !== 2) return;

    setPage(0);

    const data = {
      clientId: 0,
      page: 1,
      pageSize: pageSize,
      isMapped: isMapped === 1 ? true : isMapped === 2 ? false : "",
      categoryId: categoryId ? categoryId : "",
      serviceTypeId: parseInt(serviceTypeId) === 3 ? "" : serviceTypeId || "",
    };

    if (trainigtype === 1) {
      data.lessonId = lessonid;
      data.client = debouncedSearchClients || "";
      getMappedGlobalLessonListApi(data);
    } else {
      data.courseId = courseid;
      data.client = debouncedSearchClients || "";
      getMappedGlobalCourseListApi(data);
    }
  }, [debouncedSearchClients]);

  useEffect(() => {
    if (!debouncedClientSearch) return;

    searchClient(debouncedClientSearch);
  }, [debouncedClientSearch]);

  useEffect(() => {
    if (!debouncedLessonSearch) return;

    searchLessons(debouncedLessonSearch);
  }, [debouncedLessonSearch]);

  return (
    <>
      <div className="overidePersonal"></div>
      <div className="headerWrapper">
        <div className="headerTitle">{"Learning Management Mapping"}</div>
        <div className="headerBox">
          <div className="headerLeft">
            <ul>
              <li
                className={tabclick === 1 ? "lmsmapping active" : "lmsmapping"}
                onClick={() => onclicktab(1)}
              >
                {"Lesson/Course"}
              </li>
              <li
                className={tabclick === 2 ? "active" : ""}
                onClick={() => onclicktab(2)}
              >
                {"Clients"}
              </li>
            </ul>
          </div>
        </div>
      </div>
      {tabclick === 1 ? (
        <>
          <Grid container>
            <Grid item lg={4} xs={12} sm={12} md={6} mr={2} mt={2}>
              {ORG_ID() !== LOGIN_ORG_ID() ? (
                <FormControl fullWidth>
                  <FormLabels label="Select Client" isRequired={false} />
                  <InputField
                    isRequired={false}
                    type="text"
                    placeholder={"Add Client Name Here..."}
                    value={clients?.value}
                    disabled={ORG_ID() !== 1}
                  />
                </FormControl>
              ) : (
                <FormControl fullWidth>
                  <FormLabels label="Select Client" isRequired={true} />

                  <SearchAutoComplete
                    name="orgName"
                    placeholderText="Search Client"
                    noOptionsTextMsg="No Client"
                    optionsData={
                      allClients?.data?.filter(
                        (user) => user.Status !== 0 && user?.key !== "1",
                      ) ?? []
                    }
                    isKeyValuePair={true}
                    // typeOnchange={(event, value) => typeOnchange(event, value)}
                    typeOnchange={(event, value) => {
                      setClientSearchText(event?.target?.value || "");
                    }}
                    value={clients}
                    onChange={(event, value) => onChangeClients(value)}
                    isLoading={isSearchClientLoading}
                    autoCompClear={autoComp}
                    disabled={
                      parseInt(LOGIN_ORG_ID()) !== parseInt(HBNEXT_ORG_ID)
                    }
                  />
                  {isclientlessonSearchError && (
                    <div className="errorMsg">
                      Please enter this required field
                    </div>
                  )}

                  {isclientCourseSearchError && (
                    <div className="errorMsg">
                      Please enter this required field
                    </div>
                  )}
                </FormControl>
              )}
            </Grid>
            <Grid item lg={4} xs={12} sm={12} md={6} mr={2} mt={2}>
              <FormControl fullWidth={true}>
                <FormLabels label="Select Training Type" isRequired={true} />
                <SelectMenu
                  listData={TRAINING_OPTION}
                  value={trainigtype}
                  onchangehandler={(e) => onChangeTrainingType(e)}
                  placeholder="Please Select"
                />
              </FormControl>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item lg={10} xs={12} sm={12} md={10} mr={2} mt={2}>
              <div className="div-filter-container">
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>

                    <FilterCommonStatusSelect
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      category={categoryId}
                      handleApply={handleApply}
                      handleClear={handleClear}
                      categoryOnChanges={categoryOnChanges}
                      filterSelect={true}
                      resetBtn={true}
                      filterDate={false}
                      filterMap={true}
                      mappedOnChanges={mappedOnChanges}
                      isMapped={isMapped}
                      categoryType={categoryListData?.categoryList}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid container>
            <Grid item lg={4} xs={12} sm={12} md={6} mr={2} mt={2}>
              <FormControl fullWidth={true}>
                <FormLabels label="Select Training Type" isRequired={true} />
                <SelectMenu
                  listData={TRAINING_OPTION}
                  value={trainigtype}
                  onchangehandler={(e) => onChangeTrainingType(e)}
                  placeholder="Please Select"
                />
              </FormControl>
            </Grid>
            {trainigtype === 1 ? (
              <Grid item lg={4} xs={12} sm={12} md={6} mr={2} mt={2}>
                <FormControl fullWidth>
                  <FormLabels label="Select Lesson" isRequired={true} />

                  <SearchAutoComplete
                    name="orgName"
                    placeholderText="Search lesson"
                    noOptionsTextMsg="No lesson"
                    optionsData={searchLessonsData ?? []}
                    isKeyValuePair={true}
                    // typeOnchange={(event, value) =>
                    //   typeOnchangeLessons(event, value)
                    // }
                    typeOnchange={typeOnchangeLessons}
                    onChange={(event, value) => onChangeLessons(value)}
                    value={lessons}
                    autoCompClear={autoCompLesson}
                    errorMsg={
                      islessonSearchError
                        ? "Please enter this required field"
                        : ""
                    }
                    isLoading={isSearchLessonsLoading}
                  />
                </FormControl>
              </Grid>
            ) : (
              <Grid item lg={4} xs={12} sm={12} md={6} mr={2} mt={2}>
                <FormControl fullWidth>
                  <FormLabels label="Select Course" isRequired={true} />

                  <SearchAutoComplete
                    name="orgName"
                    placeholderText="Search Course"
                    noOptionsTextMsg="No Course"
                    optionsData={searchCoursesData ?? []}
                    isKeyValuePair={true}
                    typeOnchange={(event, value) =>
                      typeOnchangeCourses(event, value)
                    }
                    onChange={(event, value) => onChangeCourses(value)}
                    value={courses}
                    autoCompClear={autoCompCourses}
                    isError={iscourseSearchError}
                    errorMsg={
                      iscourseSearchError
                        ? "Please enter this required field"
                        : ""
                    }
                    isLoading={isSearchCoursesLoading}
                  />
                </FormControl>
              </Grid>
            )}
          </Grid>
          <Grid container>
            <Grid item lg={10} xs={12} sm={12} md={10} mr={2} mt={2}>
              <div className="div-filter-container">
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={searchClients}
                          className=""
                          onChange={handleautoSearchClients}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  <div className="filter_btn">
                    <button
                      aria-describedby={id}
                      variant="contained"
                      type="button"
                      name="btn"
                      onClick={(e) => handleClick(e)}
                    >
                      <FilterListIcon id="icn" /> Filters
                    </button>

                    <FilterCommonStatusSelect
                      id={id}
                      open={open}
                      anchorEl={anchorEl}
                      handleClose={handleClose}
                      category={serviceTypeId}
                      handleApply={handleApplyClients}
                      handleClear={handleClearClients}
                      categoryOnChanges={serviceTypeOnChanges}
                      categoryType={[...PRODUCT_LIST, { key: 3, value: "All" }]}
                      selectLable={"Service Type"}
                      filterSelect={true}
                      resetBtn={true}
                      filterDate={false}
                      filterMap={true}
                      mappedOnChanges={mappedOnChanges}
                      isMapped={isMapped}
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </>
      )}
      {tabclick === 1 && (
        <Grid mt={3}>
          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  rowCount={
                    trainigtype === 1 ? lessonCount : (courseCount ?? 0)
                  }
                  getRowId={
                    trainigtype === 1 ? (r) => r?.lessonId : (r) => r?.courseId
                  }
                  rows={lessonCourserows ?? []}
                  columns={trainigtype === 1 ? columnsLms : columnsLmsCourse}
                  disableRowSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  loading={
                    trainigtype === 1 && tabclick === 1
                      ? MappedGlobalLessonListData.isLoading
                      : MappedGlobalCourseListData.isLoading
                  }
                  checkboxSelection={true}
                  page={page}
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  pagination
                  selectionModel={[...selectedLessonCourseRows]}
                  onSelectionModelChange={handleLessonCourseChange}
                  disableSelectionOnClick
                />
              )}
            </div>
          </div>
        </Grid>
      )}
      {tabclick === 2 && (
        <Grid mt={3}>
          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  rowCount={
                    trainigtype === 1 ? lessonCount : (courseCount ?? 0)
                  }
                  // getRowId={(r) => r?.clientOrgId + getRandomNumber()}
                  getRowId={(r) => r?.clientOrgId}
                  rows={clientRows}
                  columns={
                    trainigtype === 1 ? columnsClients : columnsClientsCourse
                  }
                  disableRowSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                  loading={
                    trainigtype === 1 && tabclick === 2
                      ? MappedGlobalLessonListData.isLoading
                      : MappedGlobalCourseListData.isLoading
                  }
                  checkboxSelection={true}
                  page={page}
                  pageSize={pageSize}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handleClientPageSizeChange}
                  onPageChange={handleClientPagignation}
                  pagination
                  selectionModel={[...selectedClientRows]}
                  onSelectionModelChange={handleSelectionChange}
                  disableSelectionOnClick
                />
              )}
            </div>
          </div>
        </Grid>
      )}
      <Grid item container mt={3} spacing={2} className="lmssavecancelbtn">
        <Grid lg={2} xs={12} sm={6} md={4}>
          <Buttons
            varientText={true}
            label="Cancel"
            onClick={() => history(-1)}
          />
        </Grid>
        <Grid lg={2} xs={12} sm={6} md={4}>
          <Buttons
            varientContained={true}
            label={"Save"}
            disabled={
              (tabclick === 1 && lessonCourseMapped?.length === 0) ||
              (tabclick === 2 && clientMapped?.length === 0)
                ? true
                : false
            }
            onClick={
              tabclick === 1
                ? () => addlmsFinalData()
                : () => addClientFinalData()
            }
          />
        </Grid>
      </Grid>
    </>
  );
};

export default LmsClientMapping;
